module.exports = __webpack_public_path__ + "img/thumb-circuits-egypte-la-terre-eternelle.b8389cd9.jpeg";